export default "/images/close-yellow.svg?662ec1559feba63e0edfd5dcbbed88ef";